// Module
var code = "<div layout=\"column\">\r\n<label>{{::vm.label}}</label>\r\n\t<div layout=\"row\">\r\n\t\t<mx-checkbox ng-repeat=\"type in vm.types track by type.value\" ng-model=\"vm.supportedTypes[type.value]\" label=\"{{type.name}}\"></mx-checkbox>\r\n\t</div>\r\n</div>";
// Exports
export default code;